var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "View",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.365,
    height: 15.854,
    viewBox: "0 0 20.365 15.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72205",
    "data-name": "Path 72205",
    d: "M21.75,10.4A11.23,11.23,0,0,0,12.185,4.66,11.23,11.23,0,0,0,2.62,10.4a4.191,4.191,0,0,0,0,4.379,11.23,11.23,0,0,0,9.565,5.737,11.248,11.248,0,0,0,9.565-5.737A4.191,4.191,0,0,0,21.75,10.4ZM20.3,13.885a9.594,9.594,0,0,1-8.114,4.931,9.594,9.594,0,0,1-8.114-4.931,2.483,2.483,0,0,1,0-2.606,9.594,9.594,0,0,1,8.114-4.922A9.581,9.581,0,0,1,20.3,11.288a2.468,2.468,0,0,1,0,2.6Z",
    transform: "translate(-2.003 -4.66)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72206",
    "data-name": "Path 72206",
    d: "M13.244,9a4.244,4.244,0,1,0,4.244,4.244A4.245,4.245,0,0,0,13.244,9Zm0,6.79a2.546,2.546,0,1,1,2.546-2.546A2.543,2.543,0,0,1,13.244,15.79Z",
    transform: "translate(-3.061 -5.317)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.c6e0e6ba961ae5585fd6f94edf03b9e9.svg";
export { ForwardRef as ReactComponent };